import React, { useEffect, useState } from "react";
import "./ui.css";
import { Btn, FormInput, FormTextArea, SuccessComp } from "../../utils/utils";
// import { useNavigate } from "react-router-dom";
import { AxiosGet, AxiosPost } from "../../api/api";
import Loading from "./Loading";
import SwiperComp from "../swiper/Swiper";
import callIcon from "../../assets/call.png";
import emailIcon from "../../assets/email.png";
import locationIcon from "../../assets/location.png";
import addressIcon from "../../assets/address.png";
import HouseCard from "./HouseCard";

const DevHouseDetails = ({ houseWidth, styleBg, leftWidth }) => {
  const user = JSON.parse(localStorage.getItem("apk"));
  const devProp = JSON.parse(localStorage.getItem("property"));
  const url = "property/schedule-visit/";
  //   const navigate = useNavigate();
  const propDevUrl = `developers/properties/${devProp?.id}/`;

  const [data, setData] = useState({
    name: "",
    phoneNumber: "",
    message: "",
    email: "",
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    phoneNumber: "",
    message: "",
    email: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSingleLoading, setIsSingleLoading] = useState(false);
  const [clickOProp, setClickOProp] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [propData, setPropData] = useState("");

  const handleData = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const getSingleAgentProp = () => {
    setIsSingleLoading(true);
    AxiosGet(propDevUrl)
      .then((res) => {
        // console.log(res);
        setPropData(res.data);
        setIsSingleLoading(false);
      })
      .catch((err) => {
        // console.log(err);
        setIsSingleLoading(false);
      });
  };

  useEffect(() => {
    getSingleAgentProp();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // eslint-disable-next-line
  }, [clickOProp]);

  const dataObj = {
    propertyId: propData?.id,
    name: data?.name,
    email: data?.email,
    phoneNumber: data?.phoneNumber,
    message: data?.message,
  };

  const submitSchedule = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setTimeout(() => {
          setSuccessMsg("");
        }, 3000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  const clickProp = (item) => {
    localStorage.setItem("property", JSON.stringify(item));
    window.location.reload();
    setClickOProp(true);
  };
  // console.log(propData);

  return (
    <>
      {isSingleLoading && <Loading />}
      {!isSingleLoading && (
        <div className="house-details" style={{ width: houseWidth }}>
          <SuccessComp message={successMsg} />
          <div className="house-details_top">
            <SwiperComp images={propData?.pictures} />
            {/* <div className="details-left">
          <img src={propData?.images?.[0]?.link} alt="house" />
        </div> */}
            {/* <div className="details-right"> */}
            {/* {propData?.images?.map((item, i) => {
            return(
              <img key={i} src={item?.link} alt="house" />
            )
          })} */}
            {/* {propData?.images?.[2]?.link && (
            <div className="details-view_cont">
              <img src={propData?.images?.[2]?.link} alt="house" />
              <div className="details-view">
                <p>View Photos</p>
              </div>
            </div>
          )} */}
            {/* </div> */}
          </div>
          <div className="house-details_btm">
            <div className="house-info">
              <div className="info-left" style={{ width: leftWidth }}>
                <div className="info-head">
                  <div className="info-head_left">
                    <div style={{ display: "inline-flex" }}>
                      <h3>{propData?.propertyType}</h3>
                    </div>

                    <h2>{propData?.name}</h2>
                    <p>{propData?.address}</p>
                  </div>
                  {propData?.pricePerUnit && (
                    <div className="info-head_right">
                      <h5>{`#${propData?.pricePerUnit?.toLocaleString()}`}</h5>
                    </div>
                  )}
                </div>
                <div
                  className="info-prev info-style"
                  style={{ background: styleBg }}
                >
                  <h4>Property Overview</h4>
                  <div className="infor-prev_btm-cont">
                    {propData?.availability && (
                      <div className="infor-prev_btm">
                        <h4>Property Availability:</h4>
                        <p>{propData?.availability}</p>
                      </div>
                    )}
                    {propData?.isVerified && (
                      <div className="infor-prev_btm">
                        <h4>Property Verification Status</h4>
                        <p>
                          {propData?.isVerified ? "Verified" : "Not-Verified"}
                        </p>
                      </div>
                    )}
                    {propData?.numberOfUnits && (
                      <div className="infor-prev_btm">
                        <h4>Number of Units:</h4>
                        <p>{propData?.numberOfUnits}</p>
                      </div>
                    )}
                    {propData?.availableUnits && (
                      <div className="infor-prev_btm">
                        <h4>Available Units:</h4>
                        <p>{propData?.availableUnits}</p>
                      </div>
                    )}
                  </div>
                  <div className="prop_desc">
                    <h3>Amenities</h3>
                    {propData?.amenities?.map((item, idx) => {
                      return <p key={idx}>{item}</p>;
                    })}
                  </div>
                </div>

                <div
                  className="info-desc info-style"
                  style={{ background: styleBg }}
                >
                  <h4>Property Description</h4>
                  <p>{propData?.propertyDescription}</p>
                </div>
                {/* <div className="info-map info-style">
              <img src={map} alt="map" />
            </div> */}
              </div>
              {!user && (
                <div className="info_right_cont">
                  <div className="info-right">
                    <h3>Reach out to Developer</h3>
                    <div className="info-right_form">
                      <FormInput
                        type="text"
                        label={"Full Name"}
                        labelBg={"#FFF8F2"}
                        changeInput={handleData}
                        id={"name"}
                        err={dataErr?.name}
                      />
                      <FormInput
                        type="text"
                        label={"Email Address"}
                        labelBg={"#FFF8F2"}
                        changeInput={handleData}
                        id={"email"}
                        err={dataErr?.email}
                      />
                      <FormInput
                        type="text"
                        label={"Phone Number"}
                        labelBg={"#FFF8F2"}
                        changeInput={handleData}
                        id={"phoneNumber"}
                        err={dataErr?.phoneNumber}
                      />
                      <FormTextArea
                        label={"Drop a message"}
                        labelBg={"#FFF8F2"}
                        changeInput={handleData}
                        id={"message"}
                        err={dataErr?.message}
                      />
                      <div className="info-form_btn">
                        <Btn
                          btnClass={"home-btn"}
                          btnText={"Send Message"}
                          loading={isLoading}
                          btnClick={submitSchedule}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="info-right">
                    <h3>Developer Contact Details</h3>
                    <div className="con_info">
                      <img src={addressIcon} alt="info_icon" />
                      <h5>{propData?.developerDetails?.name}</h5>
                    </div>
                    <div className="con_info">
                      <img src={callIcon} alt="info_icon" />
                      <h5>{propData?.developerDetails?.phoneNumber}</h5>
                    </div>
                    <div className="con_info">
                      <img src={locationIcon} alt="info_icon" />
                      <h5>{propData?.developerDetails?.city}</h5>
                    </div>
                    <div className="con_info">
                      <img src={emailIcon} alt="info_icon" />
                      <h5>{propData?.developerDetails?.email}</h5>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="other_prop">
            <h3>Other properties by this developer</h3>
            <div className="dev_home_body">
              {propData?.otherProperties?.map((item, idx) => {
                return (
                  <HouseCard
                    key={idx}
                    img={item?.pictures[0]?.link}
                    tag={item?.isVerified ? "Verified" : "Not Verified"}
                    title={item?.name}
                    add={item?.address}
                    area={item?.propertyType}
                    // bed={item?.bedrooms}
                    // bath={item?.bathrooms}
                    // price={`#${item?.propertyPrice?.toLocaleString()}`}
                    btnClick={() => clickProp(item)}
                    houseStyle={{ width: "20%" }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DevHouseDetails;
